/* VosMontres — jauge de réserve de marche */
(function () {
  var arc = document.getElementById('vm-arc');
  var pct = document.getElementById('vm-pct');
  var jauge = document.getElementById('vm-reserve');
  if (!arc || !pct || !jauge) return;

  var C = 2 * Math.PI * 40;
  var utile = C * 0.75;
  var tick = false;

  function maj() {
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var p = max > 0 ? Math.min(1, h.scrollTop / max) : 0;
    arc.setAttribute('stroke-dasharray', (utile * p) + ' ' + C);
    pct.textContent = Math.round(p * 100);
    if (h.scrollTop > 220) {
      jauge.classList.add('on');
    } else {
      jauge.classList.remove('on');
    }
  }

  window.addEventListener('scroll', function () {
    if (tick) return;
    tick = true;
    requestAnimationFrame(function () { maj(); tick = false; });
  }, { passive: true });

  maj();
})();